/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedNavbarRouteImport } from './routes/_authenticated/_navbar'
import { Route as AuthenticatedNavbarIndexRouteImport } from './routes/_authenticated/_navbar/index'
import { Route as AuthenticatedNavbarUploadAnalytesRouteImport } from './routes/_authenticated/_navbar/upload-analytes'
import { Route as AuthenticatedNavbarOrganizationsRouteImport } from './routes/_authenticated/_navbar/organizations'
import { Route as AuthenticatedNavbarOrganizationSetupRouteImport } from './routes/_authenticated/_navbar/organization-setup'
import { Route as AuthenticatedNavbarListProductsRouteImport } from './routes/_authenticated/_navbar/list-products'
import { Route as AuthenticatedNavbarListAnalytesRouteImport } from './routes/_authenticated/_navbar/list-analytes'
import { Route as AuthenticatedNavbarExperimentsV2RouteImport } from './routes/_authenticated/_navbar/experiments-v2'
import { Route as AuthenticatedNavbarAdminViewRouteImport } from './routes/_authenticated/_navbar/admin-view'
import { Route as AuthenticatedNavbarSplatRouteImport } from './routes/_authenticated/_navbar/$'
import { Route as AuthenticatedNavbarExperimentsRouteRouteImport } from './routes/_authenticated/_navbar/experiments/route'
import { Route as AuthenticatedNavbarExperimentsIndexRouteImport } from './routes/_authenticated/_navbar/experiments/index'
import { Route as AuthenticatedNavbarAnalyteIndexRouteImport } from './routes/_authenticated/_navbar/analyte/index'
import { Route as AuthenticatedNavbarResultsJobIdRouteImport } from './routes/_authenticated/_navbar/results/$jobId'
import { Route as AuthenticatedNavbarLipidgroupBondTypeRouteImport } from './routes/_authenticated/_navbar/lipidgroup/$bondType'
import { Route as AuthenticatedNavbarAnalyteAnalyteIdRouteImport } from './routes/_authenticated/_navbar/analyte/$analyteId'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/route'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/interpretations/route'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/interpretations/index'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/index'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$reportId'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/metadata'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat'
import { Route as AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRouteImport } from './routes/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes'

const TermsOfUseRoute = TermsOfUseRouteImport.update({
  id: '/terms-of-use',
  path: '/terms-of-use',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedNavbarRoute = AuthenticatedNavbarRouteImport.update({
  id: '/_navbar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNavbarIndexRoute =
  AuthenticatedNavbarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarUploadAnalytesRoute =
  AuthenticatedNavbarUploadAnalytesRouteImport.update({
    id: '/upload-analytes',
    path: '/upload-analytes',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarOrganizationsRoute =
  AuthenticatedNavbarOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarOrganizationSetupRoute =
  AuthenticatedNavbarOrganizationSetupRouteImport.update({
    id: '/organization-setup',
    path: '/organization-setup',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarListProductsRoute =
  AuthenticatedNavbarListProductsRouteImport.update({
    id: '/list-products',
    path: '/list-products',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarListAnalytesRoute =
  AuthenticatedNavbarListAnalytesRouteImport.update({
    id: '/list-analytes',
    path: '/list-analytes',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsV2Route =
  AuthenticatedNavbarExperimentsV2RouteImport.update({
    id: '/experiments-v2',
    path: '/experiments-v2',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarAdminViewRoute =
  AuthenticatedNavbarAdminViewRouteImport.update({
    id: '/admin-view',
    path: '/admin-view',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarSplatRoute =
  AuthenticatedNavbarSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsRouteRoute =
  AuthenticatedNavbarExperimentsRouteRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsIndexRoute =
  AuthenticatedNavbarExperimentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarExperimentsRouteRoute,
  } as any)
const AuthenticatedNavbarAnalyteIndexRoute =
  AuthenticatedNavbarAnalyteIndexRouteImport.update({
    id: '/analyte/',
    path: '/analyte/',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarResultsJobIdRoute =
  AuthenticatedNavbarResultsJobIdRouteImport.update({
    id: '/results/$jobId',
    path: '/results/$jobId',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarLipidgroupBondTypeRoute =
  AuthenticatedNavbarLipidgroupBondTypeRouteImport.update({
    id: '/lipidgroup/$bondType',
    path: '/lipidgroup/$bondType',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarAnalyteAnalyteIdRoute =
  AuthenticatedNavbarAnalyteAnalyteIdRouteImport.update({
    id: '/analyte/$analyteId',
    path: '/analyte/$analyteId',
    getParentRoute: () => AuthenticatedNavbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdRouteRoute =
  AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport.update({
    id: '/$sampleSetId',
    path: '/$sampleSetId',
    getParentRoute: () => AuthenticatedNavbarExperimentsRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteImport.update({
    id: '/_toolbar',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute =
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteImport.update(
    {
      id: '/interpretations',
      path: '/interpretations',
      getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdRouteRoute,
    } as any,
  )
const AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute =
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute,
    } as any,
  )
const AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute =
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRouteImport.update(
    {
      id: '/$reportId',
      path: '/$reportId',
      getParentRoute: () =>
        AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute,
    } as any,
  )
const AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRouteImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRouteImport.update(
    {
      id: '/differential-analysis',
      path: '/differential-analysis',
      getParentRoute: () =>
        AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
    } as any,
  )
const AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRouteImport.update({
    id: '/data-qc',
    path: '/data-qc',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)
const AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRouteImport.update({
    id: '/analytes',
    path: '/analytes',
    getParentRoute: () => AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedNavbarIndexRoute
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/experiments': typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  '/$': typeof AuthenticatedNavbarSplatRoute
  '/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteWithChildren
  '/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/analyte/': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/experiments/': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/experiments/$sampleSetId/interpretations': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteWithChildren
  '/experiments/$sampleSetId/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute
  '/experiments/$sampleSetId/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute
  '/experiments/$sampleSetId/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute
  '/experiments/$sampleSetId/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute
  '/experiments/$sampleSetId/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute
  '/experiments/$sampleSetId/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute
  '/experiments/$sampleSetId/interpretations/$reportId': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute
  '/experiments/$sampleSetId/': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute
  '/experiments/$sampleSetId/interpretations/': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedNavbarIndexRoute
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/$': typeof AuthenticatedNavbarSplatRoute
  '/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute
  '/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/analyte': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/experiments': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/experiments/$sampleSetId/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute
  '/experiments/$sampleSetId/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute
  '/experiments/$sampleSetId/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute
  '/experiments/$sampleSetId/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute
  '/experiments/$sampleSetId/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute
  '/experiments/$sampleSetId/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute
  '/experiments/$sampleSetId/interpretations/$reportId': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute
  '/experiments/$sampleSetId/interpretations': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/sign-up': typeof SignUpRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/_authenticated/_navbar': typeof AuthenticatedNavbarRouteWithChildren
  '/_authenticated/_navbar/experiments': typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  '/_authenticated/_navbar/$': typeof AuthenticatedNavbarSplatRoute
  '/_authenticated/_navbar/admin-view': typeof AuthenticatedNavbarAdminViewRoute
  '/_authenticated/_navbar/experiments-v2': typeof AuthenticatedNavbarExperimentsV2Route
  '/_authenticated/_navbar/list-analytes': typeof AuthenticatedNavbarListAnalytesRoute
  '/_authenticated/_navbar/list-products': typeof AuthenticatedNavbarListProductsRoute
  '/_authenticated/_navbar/organization-setup': typeof AuthenticatedNavbarOrganizationSetupRoute
  '/_authenticated/_navbar/organizations': typeof AuthenticatedNavbarOrganizationsRoute
  '/_authenticated/_navbar/upload-analytes': typeof AuthenticatedNavbarUploadAnalytesRoute
  '/_authenticated/_navbar/': typeof AuthenticatedNavbarIndexRoute
  '/_authenticated/_navbar/experiments/$sampleSetId': typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren
  '/_authenticated/_navbar/analyte/$analyteId': typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  '/_authenticated/_navbar/lipidgroup/$bondType': typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  '/_authenticated/_navbar/results/$jobId': typeof AuthenticatedNavbarResultsJobIdRoute
  '/_authenticated/_navbar/analyte/': typeof AuthenticatedNavbarAnalyteIndexRoute
  '/_authenticated/_navbar/experiments/': typeof AuthenticatedNavbarExperimentsIndexRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteWithChildren
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteWithChildren
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/metadata': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$reportId': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/': typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/': typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/experiments'
    | '/$'
    | '/admin-view'
    | '/experiments-v2'
    | '/list-analytes'
    | '/list-products'
    | '/organization-setup'
    | '/organizations'
    | '/upload-analytes'
    | '/experiments/$sampleSetId'
    | '/analyte/$analyteId'
    | '/lipidgroup/$bondType'
    | '/results/$jobId'
    | '/analyte/'
    | '/experiments/'
    | '/experiments/$sampleSetId/interpretations'
    | '/experiments/$sampleSetId/analytes'
    | '/experiments/$sampleSetId/chat'
    | '/experiments/$sampleSetId/data-qc'
    | '/experiments/$sampleSetId/differential-analysis'
    | '/experiments/$sampleSetId/metadata'
    | '/experiments/$sampleSetId/samples'
    | '/experiments/$sampleSetId/interpretations/$reportId'
    | '/experiments/$sampleSetId/'
    | '/experiments/$sampleSetId/interpretations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/$'
    | '/admin-view'
    | '/experiments-v2'
    | '/list-analytes'
    | '/list-products'
    | '/organization-setup'
    | '/organizations'
    | '/upload-analytes'
    | '/experiments/$sampleSetId'
    | '/analyte/$analyteId'
    | '/lipidgroup/$bondType'
    | '/results/$jobId'
    | '/analyte'
    | '/experiments'
    | '/experiments/$sampleSetId/analytes'
    | '/experiments/$sampleSetId/chat'
    | '/experiments/$sampleSetId/data-qc'
    | '/experiments/$sampleSetId/differential-analysis'
    | '/experiments/$sampleSetId/metadata'
    | '/experiments/$sampleSetId/samples'
    | '/experiments/$sampleSetId/interpretations/$reportId'
    | '/experiments/$sampleSetId/interpretations'
  id:
    | '__root__'
    | '/_authenticated'
    | '/not-found'
    | '/privacy-policy'
    | '/sign-up'
    | '/terms-of-use'
    | '/_authenticated/_navbar'
    | '/_authenticated/_navbar/experiments'
    | '/_authenticated/_navbar/$'
    | '/_authenticated/_navbar/admin-view'
    | '/_authenticated/_navbar/experiments-v2'
    | '/_authenticated/_navbar/list-analytes'
    | '/_authenticated/_navbar/list-products'
    | '/_authenticated/_navbar/organization-setup'
    | '/_authenticated/_navbar/organizations'
    | '/_authenticated/_navbar/upload-analytes'
    | '/_authenticated/_navbar/'
    | '/_authenticated/_navbar/experiments/$sampleSetId'
    | '/_authenticated/_navbar/analyte/$analyteId'
    | '/_authenticated/_navbar/lipidgroup/$bondType'
    | '/_authenticated/_navbar/results/$jobId'
    | '/_authenticated/_navbar/analyte/'
    | '/_authenticated/_navbar/experiments/'
    | '/_authenticated/_navbar/experiments/$sampleSetId/interpretations'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/metadata'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples'
    | '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$reportId'
    | '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/'
    | '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SignUpRoute: typeof SignUpRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_navbar': {
      id: '/_authenticated/_navbar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNavbarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_navbar/': {
      id: '/_authenticated/_navbar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedNavbarIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/upload-analytes': {
      id: '/_authenticated/_navbar/upload-analytes'
      path: '/upload-analytes'
      fullPath: '/upload-analytes'
      preLoaderRoute: typeof AuthenticatedNavbarUploadAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/organizations': {
      id: '/_authenticated/_navbar/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedNavbarOrganizationsRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/organization-setup': {
      id: '/_authenticated/_navbar/organization-setup'
      path: '/organization-setup'
      fullPath: '/organization-setup'
      preLoaderRoute: typeof AuthenticatedNavbarOrganizationSetupRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/list-products': {
      id: '/_authenticated/_navbar/list-products'
      path: '/list-products'
      fullPath: '/list-products'
      preLoaderRoute: typeof AuthenticatedNavbarListProductsRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/list-analytes': {
      id: '/_authenticated/_navbar/list-analytes'
      path: '/list-analytes'
      fullPath: '/list-analytes'
      preLoaderRoute: typeof AuthenticatedNavbarListAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments-v2': {
      id: '/_authenticated/_navbar/experiments-v2'
      path: '/experiments-v2'
      fullPath: '/experiments-v2'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsV2RouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/admin-view': {
      id: '/_authenticated/_navbar/admin-view'
      path: '/admin-view'
      fullPath: '/admin-view'
      preLoaderRoute: typeof AuthenticatedNavbarAdminViewRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/$': {
      id: '/_authenticated/_navbar/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedNavbarSplatRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments': {
      id: '/_authenticated/_navbar/experiments'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsRouteRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments/': {
      id: '/_authenticated/_navbar/experiments/'
      path: '/'
      fullPath: '/experiments/'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsRouteRoute
    }
    '/_authenticated/_navbar/analyte/': {
      id: '/_authenticated/_navbar/analyte/'
      path: '/analyte'
      fullPath: '/analyte/'
      preLoaderRoute: typeof AuthenticatedNavbarAnalyteIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/results/$jobId': {
      id: '/_authenticated/_navbar/results/$jobId'
      path: '/results/$jobId'
      fullPath: '/results/$jobId'
      preLoaderRoute: typeof AuthenticatedNavbarResultsJobIdRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/lipidgroup/$bondType': {
      id: '/_authenticated/_navbar/lipidgroup/$bondType'
      path: '/lipidgroup/$bondType'
      fullPath: '/lipidgroup/$bondType'
      preLoaderRoute: typeof AuthenticatedNavbarLipidgroupBondTypeRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/analyte/$analyteId': {
      id: '/_authenticated/_navbar/analyte/$analyteId'
      path: '/analyte/$analyteId'
      fullPath: '/analyte/$analyteId'
      preLoaderRoute: typeof AuthenticatedNavbarAnalyteAnalyteIdRouteImport
      parentRoute: typeof AuthenticatedNavbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId'
      path: '/$sampleSetId'
      fullPath: '/experiments/$sampleSetId'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar'
      path: ''
      fullPath: '/experiments/$sampleSetId'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/interpretations': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/interpretations'
      path: '/interpretations'
      fullPath: '/experiments/$sampleSetId/interpretations'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/'
      path: '/'
      fullPath: '/experiments/$sampleSetId/interpretations/'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/'
      path: '/'
      fullPath: '/experiments/$sampleSetId/'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$reportId': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$reportId'
      path: '/$reportId'
      fullPath: '/experiments/$sampleSetId/interpretations/$reportId'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/samples'
      path: '/samples'
      fullPath: '/experiments/$sampleSetId/samples'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/metadata': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/metadata'
      path: '/metadata'
      fullPath: '/experiments/$sampleSetId/metadata'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis'
      path: '/differential-analysis'
      fullPath: '/experiments/$sampleSetId/differential-analysis'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/data-qc'
      path: '/data-qc'
      fullPath: '/experiments/$sampleSetId/data-qc'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat'
      path: '/chat'
      fullPath: '/experiments/$sampleSetId/chat'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
    '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes': {
      id: '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes'
      path: '/analytes'
      fullPath: '/experiments/$sampleSetId/analytes'
      preLoaderRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRouteImport
      parentRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute
    }
  }
}

interface AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute
}

const AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteChildren: AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute:
      AuthenticatedNavbarExperimentsSampleSetIdInterpretationsReportIdRoute,
    AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute:
      AuthenticatedNavbarExperimentsSampleSetIdInterpretationsIndexRoute,
  }

const AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteWithChildren =
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute._addFileChildren(
    AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteChildren,
  )

interface AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute
  AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute
}

const AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteChildren: AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarAnalytesRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarChatRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarDataQcRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarDifferentialAnalysisRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarMetadataRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarSamplesRoute,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarIndexRoute,
  }

const AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteWithChildren =
  AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute._addFileChildren(
    AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteChildren,
  )

interface AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteWithChildren
  AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteWithChildren
}

const AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren: AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRoute:
      AuthenticatedNavbarExperimentsSampleSetIdInterpretationsRouteRouteWithChildren,
    AuthenticatedNavbarExperimentsSampleSetIdToolbarRoute:
      AuthenticatedNavbarExperimentsSampleSetIdToolbarRouteWithChildren,
  }

const AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren =
  AuthenticatedNavbarExperimentsSampleSetIdRouteRoute._addFileChildren(
    AuthenticatedNavbarExperimentsSampleSetIdRouteRouteChildren,
  )

interface AuthenticatedNavbarExperimentsRouteRouteChildren {
  AuthenticatedNavbarExperimentsSampleSetIdRouteRoute: typeof AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren
  AuthenticatedNavbarExperimentsIndexRoute: typeof AuthenticatedNavbarExperimentsIndexRoute
}

const AuthenticatedNavbarExperimentsRouteRouteChildren: AuthenticatedNavbarExperimentsRouteRouteChildren =
  {
    AuthenticatedNavbarExperimentsSampleSetIdRouteRoute:
      AuthenticatedNavbarExperimentsSampleSetIdRouteRouteWithChildren,
    AuthenticatedNavbarExperimentsIndexRoute:
      AuthenticatedNavbarExperimentsIndexRoute,
  }

const AuthenticatedNavbarExperimentsRouteRouteWithChildren =
  AuthenticatedNavbarExperimentsRouteRoute._addFileChildren(
    AuthenticatedNavbarExperimentsRouteRouteChildren,
  )

interface AuthenticatedNavbarRouteChildren {
  AuthenticatedNavbarExperimentsRouteRoute: typeof AuthenticatedNavbarExperimentsRouteRouteWithChildren
  AuthenticatedNavbarSplatRoute: typeof AuthenticatedNavbarSplatRoute
  AuthenticatedNavbarAdminViewRoute: typeof AuthenticatedNavbarAdminViewRoute
  AuthenticatedNavbarExperimentsV2Route: typeof AuthenticatedNavbarExperimentsV2Route
  AuthenticatedNavbarListAnalytesRoute: typeof AuthenticatedNavbarListAnalytesRoute
  AuthenticatedNavbarListProductsRoute: typeof AuthenticatedNavbarListProductsRoute
  AuthenticatedNavbarOrganizationSetupRoute: typeof AuthenticatedNavbarOrganizationSetupRoute
  AuthenticatedNavbarOrganizationsRoute: typeof AuthenticatedNavbarOrganizationsRoute
  AuthenticatedNavbarUploadAnalytesRoute: typeof AuthenticatedNavbarUploadAnalytesRoute
  AuthenticatedNavbarIndexRoute: typeof AuthenticatedNavbarIndexRoute
  AuthenticatedNavbarAnalyteAnalyteIdRoute: typeof AuthenticatedNavbarAnalyteAnalyteIdRoute
  AuthenticatedNavbarLipidgroupBondTypeRoute: typeof AuthenticatedNavbarLipidgroupBondTypeRoute
  AuthenticatedNavbarResultsJobIdRoute: typeof AuthenticatedNavbarResultsJobIdRoute
  AuthenticatedNavbarAnalyteIndexRoute: typeof AuthenticatedNavbarAnalyteIndexRoute
}

const AuthenticatedNavbarRouteChildren: AuthenticatedNavbarRouteChildren = {
  AuthenticatedNavbarExperimentsRouteRoute:
    AuthenticatedNavbarExperimentsRouteRouteWithChildren,
  AuthenticatedNavbarSplatRoute: AuthenticatedNavbarSplatRoute,
  AuthenticatedNavbarAdminViewRoute: AuthenticatedNavbarAdminViewRoute,
  AuthenticatedNavbarExperimentsV2Route: AuthenticatedNavbarExperimentsV2Route,
  AuthenticatedNavbarListAnalytesRoute: AuthenticatedNavbarListAnalytesRoute,
  AuthenticatedNavbarListProductsRoute: AuthenticatedNavbarListProductsRoute,
  AuthenticatedNavbarOrganizationSetupRoute:
    AuthenticatedNavbarOrganizationSetupRoute,
  AuthenticatedNavbarOrganizationsRoute: AuthenticatedNavbarOrganizationsRoute,
  AuthenticatedNavbarUploadAnalytesRoute:
    AuthenticatedNavbarUploadAnalytesRoute,
  AuthenticatedNavbarIndexRoute: AuthenticatedNavbarIndexRoute,
  AuthenticatedNavbarAnalyteAnalyteIdRoute:
    AuthenticatedNavbarAnalyteAnalyteIdRoute,
  AuthenticatedNavbarLipidgroupBondTypeRoute:
    AuthenticatedNavbarLipidgroupBondTypeRoute,
  AuthenticatedNavbarResultsJobIdRoute: AuthenticatedNavbarResultsJobIdRoute,
  AuthenticatedNavbarAnalyteIndexRoute: AuthenticatedNavbarAnalyteIndexRoute,
}

const AuthenticatedNavbarRouteWithChildren =
  AuthenticatedNavbarRoute._addFileChildren(AuthenticatedNavbarRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedNavbarRoute: typeof AuthenticatedNavbarRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNavbarRoute: AuthenticatedNavbarRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SignUpRoute: SignUpRoute,
  TermsOfUseRoute: TermsOfUseRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
